import React, { useContext, useRef } from "react";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { Toast } from "primereact/toast";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";

const ListadoComprobantesDet = ({
  listadoDet,
  loading,
  setListadoDet,
  setShowDialog,
  selectedDetalle,
  setSelectedDetalle,
  getInfo,
  selectedEncabezado,
  setSelectedEncabezado
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const columns = [
    {
      field: "IdComprobanteRetencionDet",
      header: "ID",
      headerEn: "ID",
      className: "colum-width-Xlarge",
      body: (rowData) => rowData.IdComprobanteRetencionDet,
      frozen: "frozen",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      field: "FechaEmisionStr",
      header: "Fecha Emisión",
      headerEn: "Issue Date",
      className: "small",
      template: "DateTime",
      alignFrozen: "left",
    },
    {
      field: "NoComprobanteRetencion",
      header: "No. Comprobante",
      headerEn: "No. Receipt",
      className: "large",
      alignFrozen: "left",
      onCellDoubleClicked: ({ data }) => {
        if(data?.IdComprobanteRetencionEnc){
          setSelectedEncabezado([data])
          setShowDialog(true)
        }
      },
    },
    {
      // ESTADO
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "large",
      body: (rowData) => ({
        ID: rowData.IdEstado,
        Estado: rowData.StatusName,
      }),
      Format: "Estado",
    },
    {
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "XXXlarge",
    },
    {
      field: "NoDocumento",
      header: "No. Documento",
      headerEn: "No. Document",
      className: "XXXlarge",
    },
    {
      field: "FechaDocumentoStr",
      header: "Fecha Documento",
      headerEn: "Document Date",
      className: "small",
      template: "DateTime",
    },
    {
      field: "NoCAI",
      header: "CAI",
      headerEn: "CAI",
      className: "Xlarge",
    },
    {
      field: "FechaVencimientoCAI",
      header: "Fecha Venc. CAI",
      headerEn: "CAI Expiration Date",
      className: "small",
      template: "DateTime",
    },
    {
      field: "TasaCambio",
      header: "Tasa %",
      headerEn: "Rate",
      className: "Xsmall",
      Format: "Porcentaje",
      Sumary: "sum",
    },
    {
      field: "CodigoRetencion",
      header: "Code Retention",
      headerEn: "CAI Expiration Date",
      className: "small",
      Format: 'Center'
    },
    {
      field: 'DescripcionImpuestoRetenido',
      header: 'Concepto',
      headerEn: 'Concept',
      className: 'XXXlarge',
    },
    {
      header: 'Lempiras',
      headerName: 'Lempiras',

      children: [
          {
              field: 'MontoL',
              header: 'Base de Retención L',
              headerEn: 'Retention base L',
              className: 'small',
              Format: 'Currency',
              Sumary: 'sum',
              Frozen: true,
              alignFrozen: 'right'
          },
          {
              field: 'ImporteTotalL',
              header: 'Importe Total L',
              headerEn: ' Total Amount L',
              className: 'small',
              Format: 'Currency',
              Sumary: 'sum',
              Frozen: true,
              alignFrozen: 'right'
          },

      ]
  },
  {
      header: 'Dolares',
      headerName: 'Dolares',

      children: [
          {
              field: 'MontoD',
              header: 'Base de Retención $',
              headerEn: 'Retention base $',
              className: 'small',
              Format: 'Currency',
              Sumary: 'sum',
              Frozen: true,
              alignFrozen: 'right'
          },

          {
              field: 'ImporteTotalD',
              header: 'Importe Total $',
              headerEn: ' Total Amount $',
              className: 'small',
              Format: 'Currency',
              Sumary: 'sum',
              Frozen: true,
              alignFrozen: 'right'
          },
      ]
  },
  ];

  const table = {
    Columns: columns,
    Data: listadoDet,
    loading: loading,
    showModal: (e) => showModal(e),
    selected: selectedEncabezado,
    setSelected: (e) => setSelectedEncabezado(e),
  };

  const showModal = () => {
    setShowDialog(true);
  };

  return (
    <div>
      <Toast ref={toast} />
      <div style={{ height: "82vh" }}>
        <AgGrid table={table} />
      </div>
    </div>
  );
};

export default ListadoComprobantesDet;
